export const ACTOR_TAGS = Object.freeze({
    LINE_ACTOR: "line_actor",
    LINE_DUCK: "line_duck",
    LINE_WATER: "line_water",
    ACTION_CARD: "action_card",
    ACTION_CARD_CONTENT: "action_card_content",
    ACTION_CARD_IS_PLAYABLE_EFFECT: "action_card_is_playable_effect",
    LINE_SLOT: "line_slot",
    ROCK_SLOT: "rock_slot",
    HIGHLIGHT_SLOT: "highlight_slot",
    TARGET: "target",
});